import { createApp } from 'vue';
import CommonPlugin from 'plugins/common-plugin';
import { i18n } from 'utils/i18n';
import store from 'stores/generic';
import SearchField from 'components/product-search/SearchField.vue';
import BlockPagePlugin from 'plugins/block-page';

const app = createApp({
  components: { SearchField },
  methods: {
    search(term) {
      location.href = `${payload.searchPageLink}?q=${term}`;
    }
  }
});

app.use(CommonPlugin);
app.use(store);
app.use(i18n);
app.use(BlockPagePlugin);

require('styles/pages/products.less');

app.mount('#app');
